import { VpCheckbox } from '@vtmn-play/react'
import { t } from 'i18next'

type Props = {
  label: string
  done: boolean
  isCustom?: boolean
  disabled?: boolean
  onChange: (value: boolean) => void
}

const ActionCheckbox = ({ label, done, isCustom, disabled, onChange }: Props) => {
  const handleChange = (event: boolean) => {
    onChange(event)
  }
  return (
    <VpCheckbox
      data-testid="action-checkbox"
      disabled={disabled}
      checked={done}
      onChange={(e) => handleChange(e.target.checked)}
    >
      <span className="flex flex-col gap-1">
        <p className={`${done ? 'line-through' : ''}`}>{label}</p>
        {isCustom && (
          <p className="text-xs text-content-quiet font-medium">
            {t('pages.action-list.custom-action')}
          </p>
        )}
      </span>
    </VpCheckbox>
  )
}

export default ActionCheckbox
